import React from "react";
import PText from "../components/PText";
import AboutImg from "../assets/images/about-page-img.png";
import styled from "styled-components";
import AboutInfoItem from "../components/AboutInfoItem";
import ContactBanner from "../components/ContactBanner";

const AboutPageStyles = styled.div`
  padding: 20rem 0 10rem 0;
  .top-section {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2rem;
  }
  .left {
    flex: 3;
  }
  .right {
    flex: 2;
  }
  .about__subheading {
    font-size: 2.2rem;
    margin-bottom: 2rem;
    span {
      background-color: var(--deep-dark);
      padding: 0.5rem;
      border-radius: 8px;
    }
  }
  .about__heading {
    font-size: 3.6rem;
    margin-bottom: 3rem;
  }
  .about__info {
    margin-bottom: 4rem;
    .para {
      max-width: 100%;
    }
  }
  .right {
    img {
      border: 2px solid var(--gray-1);
    }
  }
  .about__info__items {
    margin-top: 15rem;
  }
  .about__info__item {
    margin-bottom: 10rem;
  }
  .about__info__heading {
    font-size: 3.6rem;
    text-transform: uppercase;
  }
  .anchor-btn {
    font-size: 2.2rem;
    background-color: ${(props) =>
      props.outline ? "transparent" : "var(--gray-1)"};
    padding: 0.7em 2em;
    border-radius: 8px;
    display: inline-block;
    border: 2px solid var(--gray-1);
    color: ${(props) => (props.outline ? "var(--gray-1)" : "black")};
  }

  @media only screen and (max-width: 768px) {
    padding: 10rem 0;
    .top-section {
      flex-direction: column;
      gap: 5rem;
    }
    .about__subheading {
      font-size: 1.8rem;
    }
    .about__heading {
      font-size: 2.8rem;
    }
    .about__info__heading {
      font-size: 3rem;
    }
    .anchor-btn {
      font-size: 1.8rem;
    }
  }
`;

const About = () => {
  return (
    <AboutPageStyles>
      <div className="container">
        <div className="top-section">
          <div className="left">
            <p className="about__subheading">
              Hi, I am <span>Tanvir Ahmed</span>
            </p>
            <h2 className="about__heading">A Software Developer</h2>
            <div className="about__info">
              <PText>
                I am from Bogura, Bangladesh. A place of beauty and nature. My
                journey in coding began in Varsity, where I discovered that
                programming is not just technical—it's an art form that allows
                me to create meaningful solutions.
                <br />
                <br />
                I build scalable web applications using the MERN stack and PHP
                frameworks like CodeIgniter and Laravel. My work includes
                developing SaaS platforms, ERP systems, and e-commerce
                solutions, with a focus on performance optimization and cloud
                management.
                <br />
                <br />
                As a Junior Developer at InleadsIT, I contribute to SquadDeck, a
                SaaS platform for sports team management, utilizing full-stack
                development and server deployment. I've also developed an ERP
                system to enhance office resource management.
                <br />
                <br />
                I'm committed to continuous learning and growth, always seeking
                new challenges to refine my skills. My ultimate vision is to
                leverage technology to create impactful solutions that
                contribute to a better world.
              </PText>
            </div>
            <a
              className="anchor-btn"
              href="https://drive.google.com/file/d/1ojF8iNo5GpSKNwLdOF-98TPfTQsvAGLa/view?usp=sharing"
              target="_blank"
              rel="noopener noreferrer"
            >
              Download CV
            </a>
          </div>
          <div className="right">
            <img src={AboutImg} alt="Tanvir Ahmed" />
          </div>
        </div>
        <div className="about__info__items">
          <div className="about__info__item">
            <h1 className="about__info__heading">Experience</h1>
            <AboutInfoItem
              title="2023 - Present"
              items={["Junior Developer at InleadsIT (NETMOW)"]}
            />
            <AboutInfoItem
              title="2020 - 2022"
              items={["Freelance Web Developer"]}
            />
          </div>
          <div className="about__info__item">
            <h1 className="about__info__heading">My Skills</h1>
            <AboutInfoItem
              title="Frontend"
              items={[
                "React.js",
                "Next.js",
                "Redux",
                "HTML",
                "CSS",
                "Bootstrap",
                "JavaScript",
                "TypeScript",
                "TailwindCSS",
              ]}
            />
            <AboutInfoItem
              title="Backend"
              items={[
                "Node",
                "Express.js",
                "PHP",
                "Laravel",
                "CodeIgniter",
                "Socket.io",
              ]}
            />
            <AboutInfoItem
              title="Database"
              items={["MySQL", "MongoDB", "PostgreSQL", "Firebase"]}
            />
            <AboutInfoItem
              title="Deployment"
              items={[
                "AWS (EC2, S3)",
                "DigitalOcean (Server, Spaces)",
                "LaravelForge",
              ]}
            />
            <AboutInfoItem
              title="Version Ctrl."
              items={["Git", "GitHub", "Bitbucket"]}
            />
            <AboutInfoItem title="Programming" items={["C", "C++", "Java"]} />
            <AboutInfoItem
              title="Others"
              items={[
                "DNS (DigitalOcean Networking)",
                "CDN (Cloudflare)",
                "FileZilla",
                "Microsoft Office",
              ]}
            />
          </div>
          <div className="about__info__item">
            <h1 className="about__info__heading">Education</h1>
            <AboutInfoItem
              title="Varsity"
              items={["TMSS Engineering College (Aff. Rajshahi University)"]}
            />
            <AboutInfoItem
              title="College"
              items={["Government Azizul Haque College, Bogura"]}
            />
            <AboutInfoItem
              title="School"
              items={["Bogra Zilla School, Bogura"]}
            />
          </div>
        </div>
      </div>
      <ContactBanner />
    </AboutPageStyles>
  );
};

export default About;
